import Guard from 'arg-guard'

/**
 * Definition of a partner and their linked schemes.
 *
 * @export {PartnerSchemes} The partner schemes.
 * @class PartnerSchemes
 */
export default class PartnerSchemes {

    /**
     * Creates a partner with linked schemes.
     * @param {number} id The id of the partner.
     * @param {string} name The name of the partner.
     * @param {Array<Scheme>|Scheme} initialSchemes A set of schemes.
     * @memberOf PartnerSchemes
     */
    constructor(id, name, initialSchemes = []) {
        Guard.throwIf(id, 'id')
        Guard.throwIf(name, 'name')

        this.id = id
        this.name = name

        /**
         * @type {Array<Scheme>}
         */
        this.linkedSchemes = Array.isArray(initialSchemes) ? initialSchemes : [ initialSchemes ]
    }
}
